export const DIRECTION = { DESC: 'DESC', ASC: 'ASC' };
